export default {
    accept_payments_for_nonclosed_visit: "Разрешить принимать оплату, если визит не закрыт",
    accountingmonth: "Бухгалтерский месяц",
    accrual: "Начисление",
    accruals: "Начисления",
    accrued: "Начислено",
    AQSI_account: "AQSI счет",
    balance_end: "Баланс на конец периода",
    balance_start: "Баланс на начало периода",
    bonus_movement: "Движение бонусов",
    cash_movements: "Движение ДС",
    cash_received: "Получено ДС",
    closed: "Закрыт",
    communal: "Коммунальные платежи",
    deduct_materials_from_doctor_salary: "Вычитать сумму материалов из зарплаты доктора",
    deduction: "Удержание",
    deposit_account: "Депозитный счет",
    deposit_accounts: "Депозитные счета",
    deposit_balance: "Остаток депозита",
    deposit_balance_end: "Остаток депозита на конец периода",
    deposit_balance_start: "Остаток депозита на начало периода",
    deposit_movement: "Движения по депозиту",
    employee: "Сотрудник",
    employee_id: "ID сотрудника",
    expense: "Расход",
    first_payment: "Первая оплата",
    fiscal_cashdesk: "Фискальная касса",
    for_payment_scan_this_qr_in_kyrgyz_bank: "Для оплаты отсканируйте данный QR-код и оплатите любым банком Кыргызстана",
    for_payment_scan_this_qr_in_obank_application: "Для оплаты отсканируйте данный QR в приложении OBank",
    income: "Доходы",
    left_to_pay: "Осталось выплатить",
    left_to_pay2: "Осталось оплатить",
    manual_adjustments: "Ручные корректировки",
    materials_cost: "Себестоимость материалов",
    materials_expense: "Расходные материалы",
    open: "Открыть",
    opened: "Открыт",
    other_expense: "Прочие расходы",
    other_income: "Прочие доходы",
    pay_out: "Выплатить",
    payment_comment: "Комментарий к оплате",
    payment_completed_successfully: "Платеж проведен успешно",
    payment_sum: "Сумма для выплаты",
    profit: "Доход",
    recalculate: "Пересчитать",
    refund_to_patient: "Возврат пациенту",
    rent: "Аренда",
    salaries: "Зарплаты",
    unclosed: "Не закрыт",
    upselling: "Допродажа"
}
